// Registrazione centralizzata di GSAP + ScrollTrigger.
// Import da qui in tutta l'app per evitare registrazioni multiple.
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Easing firma del brand: cubic-bezier(0.16, 1, 0.3, 1)
export const EASE_EXPO = "power4.out";

export { gsap, ScrollTrigger };
